import { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar.js";
import Header from "../components/Header.js";
import NumCard from "../components/NumCard.js";
import CallToAction from "../components/CallToAction.js";
import Table from "../components/Table.js";
import data from "../components/data.json";
import {
  getCompanyDetails,
  getDahboardStats,
} from "../services/companyService.js";
import { useNavigate } from "react-router-dom";
import { SquarePen } from "lucide-react";
import { useAuth } from "../context/AuthContext.js";
import { getStatusColor } from "../utils/statusUtils.js";
import StatsCards from "../components/StatsCards.js";

function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [stats, setStats] = useState([
    {
      label: "Total Forms",
      value: 0,
      color: "text-indigo-500",
      border: "border-indigo-300",
    },
    {
      label: "Approved Forms",
      value: 0,
      color: "text-green-600",
      border: "border-green-300",
    },
    {
      label: "Pending Forms",
      value: 0,
      color: "text-yellow-500",
      border: "border-yellow-300",
    },
    {
      label: "Rejected Forms",
      value: 0,
      color: "text-red-500",
      border: "border-red-300",
    },
  ]);

  const allowedStatues = [4, 5, 6, 7];

  const columns = [
    { label: "Company Name", key: "name" },
    { label: "Registered Name", key: "registeredName", align: "start" },
    { label: "Website", key: "websiteUrl", align: "start" },
    {
      label: "Industries",
      key: "industries",
      align: "center",
      format: "arrayValue",
    },
    {
      label: "Onboarded on",
      key: "createdAt",
      align: "center",
      format: "date",
    },
    {
      label: "Application Status",
      key: "applicationStatusValue",
      align: "center",
      render: (row) => (
        <span
          className={`text-white px-4 py-1 rounded-lg text-sm hover:opacity-90 ${getStatusColor(
            row.applicationStatus.id
          )}`}
          //onClick={() => redirectToForm(row)}
        >
          {row.applicationStatus.value}
        </span>
      ),
    },
    {
      label: "Action",
      key: "action",
      align: "center",
      render: (row) => (
        <button
          disabled={row?.applicationStatus?.id === 4}
          className={`text-indigo-600 hover:text-indigo-900 gap-1 ${
            allowedStatues.includes(row?.applicationStatus?.id)
              ? "cursor-not-allowed opacity-50"
              : "cursor-pointer"
          }`}
          onClick={(e) => {
            e.preventDefault();
            if (!allowedStatues.includes(row?.applicationStatus?.id)) {
              redirectToForm(row);
            }
          }}
        >
          <SquarePen />
          <span className="sr-only">Change password for {row.name}</span>
        </button>
      ),
    },
  ];

  const redirectToForm = (row) => {
    navigate(`/form?companyId=${row.companyId}&versionId=${row.version}`);
  };

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      let response = await getCompanyDetails(user);
      // FILTER FORMS FOR USER
      response = response.filter((item) =>
        item.assignedValidators.some(
          (validator) => validator.userId === user.id
        )
      );
      response = response.map((x) => ({
        ...x,
        applicationStatusValue: x.applicationStatus.value,
      }));
      console.log(response);
      setCompanies(response);
      // const statistitcs = [
      //   {
      //     amount: response.length,
      //     text: "Approved",
      //     colour: "#198754",
      //   },
      //   {
      //     amount: response.filter(
      //       (row) => row.applicationStatus.value.toLowerCase() === "pending"
      //     ).length,
      //     text: "Pending Approval",
      //     colour: "#ffb800",
      //   },
      //   {
      //     amount: response.filter(
      //       (row) => row.applicationStatus.value.toLowerCase() === "rejected"
      //     ).length,
      //     text: "Rejected",
      //     colour: "#c82333",
      //   },
      // ];
      // setStats(statistitcs);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Failed to load company data:", error);
    }
  };

  const fetchDashboard = async () => {
    const response = await getDahboardStats(user);
    setStats([
      {
        label: "Total Forms",
        value: response.totalForms,
        color: "text-indigo-500",
        border: "border-indigo-300",
      },
      {
        label: "Approved Forms",
        value: response.approvedForms,
        color: "text-green-600",
        border: "border-green-300",
      },
      {
        label: "Pending Forms",
        value: response.pendingForms,
        color: "text-yellow-500",
        border: "border-yellow-300",
      },
      {
        label: "Rejected Forms",
        value: response.rejectedForms,
        color: "text-red-500",
        border: "border-red-300",
      },
    ]);
  };

  useEffect(() => {
    fetchCompanies();
    fetchDashboard();
    // fetchStats(); // Uncomment when API is ready
  }, []);

  return (
    <div className="container py-8 px-[5rem] bg-[#fbfbfb]">
      <Header
        title="Validator Dashboard"
        date="Sunday, 22 Dec 2024"
        buttons={false}
      />
      <div className="mb-4">
        <StatsCards stats={stats} className="grid grid-cols-4 gap-4" />
      </div>
      <CallToAction className="mb-[2rem]" />
      <h2 className="text-xl font-semibold mb-2">Forms</h2>
      <p className="text-sm mb-4 text-gray-500">
        Total: {companies.length} Forms
      </p>
      <Table columns={columns} rows={companies} loading={loading} />
    </div>
  );
}
export default Dashboard;
